import { Component, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { AuthRepositoryQuery } from '../../../../../domain/repositories/auth.repository';
import { LogoutUsecase } from '../../../../../data/repositories/auth/usecases';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CategoriesRepositoryQuery } from '../../../../../domain/repositories/categories.repository';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { Subscription } from 'rxjs';
import { SkeletonModule } from 'primeng/skeleton';
import { AvatarPipe } from '../../../pipes/avatar.pipe';
import { AvatarModule } from 'primeng/avatar';

@Component({
  selector: 'otw-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    ButtonModule,
    DrawerModule,
    SkeletonModule,
    AvatarPipe,
    NgOptimizedImage,
    AvatarModule,
  ],
  templateUrl: './main-layout.component.html',
  styles: ``,
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  subscriptions = signal<Subscription[]>([]);
  isLoading = signal(false);
  userProfile = this.authRepositoryQuery.userProfile;
  isLoggedIn = this.authRepositoryQuery.isLoggedIn;
  categories = this.categoriesRepositoryQuery.categories;
  drawerVisible = false;
  constructor(
    private router: Router,
    private authRepositoryQuery: AuthRepositoryQuery,
    private categoriesRepositoryQuery: CategoriesRepositoryQuery,
    private logoutUsecase: LogoutUsecase
  ) {}

  async onLogout() {
    this.isLoading.set(true);
    const result = await this.logoutUsecase.execute();
    console.log(result);
    this.isLoading.set(false);
  }

  ngOnInit() {
    const sub = this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd && this.drawerVisible) {
        this.drawerVisible = false;
      }
    });

    this.subscriptions.update((subs) => [...subs, sub]);
  }

  ngOnDestroy() {
    this.subscriptions().forEach((s) => s.unsubscribe());
    this.subscriptions.set([]);
  }
}
